module.exports = __webpack_public_path__ + "static/media/banner-man.f5063fe5.png";